module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/photographers-tile-dbd2858ed226ab802f05af4d1a884697.jpg";